// extracted by mini-css-extract-plugin
module.exports = {"separator":"_3EDKF","postExcerpt":"_1FVC-","postTitle":"_1lccS"};